module.exports = __webpack_public_path__ + "img/inlead.fa8c1a08.png";